import { render, staticRenderFns } from "./TabelaResultadosStatusMandato.vue?vue&type=template&id=089e8f3c&scoped=true&"
import script from "./TabelaResultadosStatusMandato.vue?vue&type=script&lang=js&"
export * from "./TabelaResultadosStatusMandato.vue?vue&type=script&lang=js&"
import style0 from "./TabelaResultadosStatusMandato.vue?vue&type=style&index=0&id=089e8f3c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "089e8f3c",
  null
  
)

export default component.exports